import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted py-4 text-center"
}

import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { TimeSeries } from '@/services/adminStatsApi'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsTokenChart',
  props: {
    timeseries: {}
  },
  setup(__props: any) {

const props = __props

function formatToken(v: number): string {
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M'
  if (v >= 1_000) return Math.round(v / 1_000) + 'K'
  return v.toString()
}

const chartOptions = computed<ApexOptions>(() => ({
  chart: { toolbar: { show: false }, zoom: { enabled: false } },
  stroke: { curve: 'smooth', width: 2 },
  colors: ['#8b5cf6'],
  fill: {
    type: 'gradient',
    gradient: { opacityFrom: 0.35, opacityTo: 0.0, shadeIntensity: 1 },
  },
  dataLabels: { enabled: false },
  xaxis: {
    categories: props.timeseries.labels,
    tickAmount: 8,
    labels: { rotate: -30, style: { fontSize: '11px' } },
  },
  yaxis: { labels: { formatter: formatToken } },
  tooltip: {
    shared: true,
    intersect: false,
    y: { formatter: (v: number) => v.toLocaleString('tr-TR') + ' token' },
  },
}))

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "trezo-card bg-white border-0 shadow-none border-radius mb-0" }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "v-card-header" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Token Tüketimi (Zaman Serisi)")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        (!__props.timeseries.labels.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Veri bulunamadı "))
          : (_openBlock(), _createBlock(_component_apexchart, {
              key: 1,
              type: "area",
              height: "280",
              options: chartOptions.value,
              series: __props.timeseries.series
            }, null, 8, ["options", "series"]))
      ])
    ]),
    _: 1
  }))
}
}

})